import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { money, monthLabel } from "@/lib/money";

export default function RevenueChart({ monthly }) {
  const data = monthly.map((m) => ({ month: monthLabel(m.month), Net: m.net_cents / 100, Refunds: m.refunds_cents / 100, Discounts: m.discounts_cents / 100 }));
  return (
    <section className="brutal-border p-4 sm:p-5 mb-8" data-testid="revenue-chart">
      <div className="font-mono-label text-[10px] text-muted-foreground mb-4">CASH BY MONTH · LAST 12 MONTHS</div>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 4, left: -12, bottom: 0 }}>
            <CartesianGrid stroke="#1F1F1F" vertical={false} />
            <XAxis dataKey="month" tick={{ fill: "#8A8A8A", fontSize: 11 }} axisLine={{ stroke: "#262626" }} tickLine={false} interval="preserveStartEnd" />
            <YAxis tick={{ fill: "#8A8A8A", fontSize: 11 }} axisLine={false} tickLine={false} tickFormatter={(v) => `$${v.toLocaleString()}`} />
            <Tooltip cursor={{ fill: "#ffffff0d" }} contentStyle={{ background: "#0A0A0A", border: "1px solid #262626", fontSize: 12 }}
              formatter={(v) => money(Math.round(v * 100))} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar dataKey="Net" fill="#FFD600" />
            <Bar dataKey="Refunds" fill="#F87171" />
            <Bar dataKey="Discounts" fill="#60A5FA" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
